import React, { useEffect, useState } from 'react';
import StepOne from './Components/StepOne';
import StepTwo from './Components/StepTwo';
import StepThree from './Components/StepThree';
import { winnreAuth } from '../../utils/axios';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';
import { toast } from 'react-toastify';
import { authActions } from '../../store/auth-slice';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useInput } from '../../Hooks';
import { RE_Pin } from '../../constants';
import Modal from '../../Components/Organisms/Modal';
import GrClose from '@meronex/icons/gr/GrClose';
import { getConfig } from '../../utils/config';

const RentalForm = () => {
    const dispatch = useDispatch();
    const config = getConfig();
    const [step, setStep] = useState(1);
    const [propertyData, setPropertyData] = useState([]);
    const [selectedProject, setSelectedProject] = useState(null);
    const [furnish, setFurnish] = useState(null);
    const [furnishType, setFurnishType] = useState(null);
    const [rentOutTime, setRentOutTime] = useState(null);
    const [expectedRent, setExpectedRent] = useState(null);
    const [securityDeposit, setSecurityDeposit] = useState(null);
    const [formattedDate, setFormattedDate] = useState(null);
    const [loading, setLoading] = useState(false);
    const [city, setCity] = useState('');
    const [state, setState] = useState('');
    const [address, setAddress] = useState('');

    const [listOtherProperty, setListOtherProperty] = useState(false);
    const [showUnregisteredModal, setShowUnregisteredModal] = useState(false);

    const {
        value: Pin,
        isValid: PinIsValid,
        hasError: PinHasError,
        valueChangeHandler: PinChangedHandler,
        inputBlurHandler: PinBlurHandler,
        reset: resetPin
    } = useInput((value) => RE_Pin.test(value));

    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
    const userName = useSelector((state) => state.auth);

    const openLoginModal = () => {
        dispatch(authActions.openLoginModal());
    };

    // useEffect(() => {
    //     if (!isAuthenticated) {
    //         openLoginModal();
    //     }
    // }, [isAuthenticated]);

    const getPropertyData = () => {
        winnreAuth({
            method: 'GET',
            url: '/winnre/user/property/customer'
        }).then((res) => {
            console.log('propertyData', res);
            setPropertyData(
                res?.content?.map((obj) => {
                    return {
                        id: obj?.propertyId,
                        projectName: obj?.projectName,
                        projectId: obj?.projectId,
                        projectBgImage: obj?.projectBgImage,
                        unitArea: obj?.unitArea,
                        configuration: obj?.configurationName
                    };
                })
            );
        });
    };

    useEffect(() => {
        getPropertyData();
    }, [isAuthenticated]);

    const calculateDate = (time) => {
        const today = new Date();
        let targetDate;

        switch (time) {
            case 'Immediately':
                targetDate = today;
                break;
            case '2 weeks':
                targetDate = new Date(today.setDate(today.getDate() + 14));
                break;
            case '1 month':
                targetDate = new Date(today.setMonth(today.getMonth() + 1));
                break;
            case 'After 2 months':
                targetDate = new Date(today.setMonth(today.getMonth() + 2));
                break;
            default:
                targetDate = today;
        }

        return targetDate.toISOString().split('T')[0];
    };

    const handleSetRentOutTime = (time) => {
        setRentOutTime(time);
        const formatted = calculateDate(time);
        setFormattedDate(formatted);
    };

    const handleSubmit = () => {
        setLoading(true);
        winnreAuth({
            method: 'POST',
            url: `/winnre/user/deals/redeem-v2?dealId=-1`
        })
            .then((res) => {
                console.log('Redeem API Response:', res);

                const dealRedemptionId = res?.dealRedemptionId; // Extract ID
                // if (!dealRedemptionId) {
                //     toast.error(res?.message);
                //     setLoading(false);
                //     return Promise.reject('dealRedemptionId is missing'); // Prevent further execution
                // }
                if (!dealRedemptionId) {
                    if (
                        res?.status === 'FAILED' &&
                        res?.message ===
                            'Deal redemption is not allowed for this user'
                    ) {
                        toast.error(
                            'You can’t submit a rental request until your profile is approved. Once verified, you’ll have full access to rentals.'
                        );
                    } else {
                        toast.error('Something went wrong');
                    }
                    setLoading(false);
                    return Promise.reject('dealRedemptionId is missing');
                }

                // Now Call Submit API
                let data = {
                    unitArea: selectedProject?.unitArea,
                    unitConfiguration: selectedProject?.configuration,
                    furnishType: furnishType,
                    rentOutTime: formattedDate,
                    rentalAmount: expectedRent,
                    securityDeposit: securityDeposit,
                    pincode: Pin,
                    state: state,
                    city: city,
                    addressLine1: address
                };

                let url = `winnre/user/deals/consultation-deal-additional-details?dealRedemptionId=${dealRedemptionId}`;

                return winnreAuth({
                    method: 'POST',
                    url,
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8'
                    },
                    data: JSON.stringify(data)
                });
            })
            .then((res) => {
                if (!res) return; // Prevents executing success logic if rejected earlier

                setLoading(false);
                console.log('Consultation Deal Response:', res);
                if (
                    res?.status === 'INVALID_TOKEN' ||
                    res?.status === 'FAILED'
                ) {
                    toast.error('Something Went Wrong');
                    return;
                }

                window?.webengage?.track('SubmitClicked');
                setStep(3);
                setListOtherProperty(false);
            })
            .catch((err) => {
                console.error('Error:', err);
                // toast.error('Something Went Wrong');
                setLoading(false);
            });
    };

    const getConditionalFormStep = () => {
        switch (step) {
            case 1:
                return (
                    <StepOne
                        setStep={setStep}
                        propertyData={propertyData}
                        selectedProject={selectedProject}
                        setSelectedProject={setSelectedProject}
                        listOtherProperty={listOtherProperty}
                        setListOtherProperty={setListOtherProperty}
                        setFurnishType={setFurnishType}
                        setRentOutTime={setRentOutTime}
                        setExpectedRent={setExpectedRent}
                        setSecurityDeposit={setSecurityDeposit}
                        setCity={setCity}
                        setAddress={setAddress}
                        setState={setState}
                        resetPin={resetPin}
                        setShowUnregisteredModal={setShowUnregisteredModal}
                    />
                );
            case 2:
                return (
                    <StepTwo
                        setStep={setStep}
                        selectedProject={selectedProject}
                        setSelectedProject={setSelectedProject}
                        furnishType={furnishType}
                        setFurnishType={setFurnishType}
                        setFurnish={setFurnish}
                        rentOutTime={rentOutTime}
                        setRentOutTime={setRentOutTime}
                        expectedRent={expectedRent}
                        setExpectedRent={setExpectedRent}
                        securityDeposit={securityDeposit}
                        setSecurityDeposit={setSecurityDeposit}
                        handleSetRentOutTime={handleSetRentOutTime}
                        handleSubmit={handleSubmit}
                        loading={loading}
                        Pin={Pin}
                        PinChangedHandler={PinChangedHandler}
                        PinHasError={PinHasError}
                        PinBlurHandler={PinBlurHandler}
                        PinIsValid={PinIsValid}
                        city={city}
                        setCity={setCity}
                        state={state}
                        setState={setState}
                        address={address}
                        setAddress={setAddress}
                        listOtherProperty={listOtherProperty}
                    />
                );
            case 3:
                return (
                    <StepThree
                        setStep={setStep}
                        setPropertyData={setPropertyData}
                        selectedProject={selectedProject}
                        furnishType={furnishType}
                        setFurnish={setFurnish}
                        formattedDate={formattedDate}
                        expectedRent={expectedRent}
                        securityDeposit={securityDeposit}
                        setSelectedProject={setSelectedProject}
                        setFurnishType={setFurnishType}
                        furnish={furnish}
                        setRentOutTime={setRentOutTime}
                        setExpectedRent={setExpectedRent}
                        setSecurityDeposit={setSecurityDeposit}
                        listOtherProperty={listOtherProperty}
                    />
                );
            default:
                <></>;
        }
    };
    return (
        <div
            className={
                `${config?.blogs.overlayClass ? 'relative' : ''} ${
                    config?.darkMode ? 'bg-black' : ''
                }` + ' h-full w-full pt-5 pb-10'
            }
            style={{
                backgroundImage: `linear-gradient(90deg, rgba(${
                    config?.sectionBackground?.color
                }, ${config?.sectionBackground?.opacity}), rgba(${
                    config?.sectionBackground?.color
                }, ${config?.sectionBackground?.opacity})), url('${
                    config?.sectionBackground?.image
                        ? config?.sectionBackground?.image
                        : ''
                }')`,
                backgroundSize: `${
                    config?.sectionBackground?.size
                        ? config?.sectionBackground?.size
                        : '30% auto'
                }`,
                backgroundAttachment: 'fixed'
            }}
        >
            {getConditionalFormStep()}

            {showUnregisteredModal && (
                <Modal
                    className="w-[95%] md:w-[55%] lg:w-[50%] xl:w-[45%]"
                    visible={showUnregisteredModal}
                    onClick={() => setShowUnregisteredModal(false)}
                >
                    <div className="flex justify-end mr-4 mt-4">
                        <GrClose
                            onClick={() => setShowUnregisteredModal(false)}
                            className={` h-4 w-4 cursor-pointer self-end ml-auto`}
                        />
                    </div>
                    <div className="text-left px-4 pb-8">
                        <h1 className="font-bold text-xl">Hello There</h1>
                        <p className="text-sm lg:text-base font-medium mt-2">
                            Your registration is being reviewed.
                        </p>
                        <p className="text-sm lg:text-base font-medium mt-1">
                            Once approved, you'll be able to proceed with
                            listing your property for rent.
                        </p>
                    </div>
                </Modal>
            )}
        </div>
    );
};

export default RentalForm;
